<template>
  <div class="forgot-password">
    <img src="@/assets/logo_all_blue.png" class="logo" />

    <div class="inputs">

      <dg-input type="password" v-model="formData.password" placeholder="Password" icon="lock" :error="errors.password"/>
      <dg-input type="password" v-model="formData.confirmPassword" placeholder="Password again" icon="lock" @keyup.enter.native="resetPassword" :error="errors.confirmPassword"/>

      <el-button :loading="loading" type="primary" @click="resetPassword" class="forgot-button" style="margin-bottom: 15px;">Reset</el-button>
      <router-link to="/signin" tag="button" class="el-button el-button--text signin-button">Back to sign in</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data () {
    return {
      formData: {
        token: '',
        password: '',
        confirmPassword: ''
      },
      errors: {
        password: null,
        confirmPassword: null
      },
      loading: false
    }
  },
  methods: {
    setErrors (data) {
      for (let k in data) {
        this.errors[k] = data[k]
      }
    },
    async resetPassword () {
      this.loading = true
      try {
        const response = await this.$http.post(this.$api.auth.reset(this.$route.params.uid), this.formData)
        this.$message.success('Password reset, you can now login.')
        this.$router.push({ name: 'Signin' })
      } catch (error) {
        this.setErrors(error.response.data)
      }
      this.loading = false
    }
  },
  created () {
    if (!this.$route.query.token && !this.$route.params.uid) {
      this.$router.push('/')
    }
    this.formData.token = decodeURIComponent(this.$route.query.token)
    if (this.$auth.isLoggedIn()) {
      this.$router.push((this.redirect && this.redirect.length > 0) ? this.redirect : '/dashboard/')
    }
  }
}
</script>

<style lang="scss" scoped>

  .forgot-password {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;

    @include breakpoint (xs) {
      max-height: 100vh;
    }
  }

  .logo {
    width: 160px;
    height: auto;
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
  }

  .inputs {
    width: 300px;
    margin: 0 auto;
    margin-top: 50px;

    .dg-input {
      margin-bottom: 20px;
    }

    button {
      margin-top: 20px;
    }
  }


  .forgot-button, .signin-button {
    width: 100%;
    display: block;
  }

  .signin-button {
    font-size: 14px !important;
    margin-left: 0px;
  }

  .some-alert {
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/front/ResetPassword.vue